

























































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";
export default Vue.extend({
  name: "TagEdit",
  data() {
    return {
      dialog: false,
      loading: false,
      ruleForm: {
        hosts: [] as string[],
        tags: [["", ""]] as [string, string][]
      }
    };
  },
  methods: {
    show(data: string[], tags: object) {
      this.ruleForm.hosts = data;
      this.ruleForm.tags = [...Object.entries(tags)];
      if (this.ruleForm.tags.length === 0) {
        this.ruleForm.tags.push(["", ""]);
      }
      this.dialog = true;
    },
    delTag(index: number) {
      this.ruleForm.tags.splice(index, 1);
    },
    addTag() {
      this.ruleForm.tags.push(["", ""]);
    },
    quit() {
      this.ruleForm = {
        hosts: [] as string[],
        tags: [["", ""]]
      };
      (this.$refs.ruleForm as Form).clearValidate();

      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
        if (valid) {
          this.loading = true;
          this.create();
        }
      });
    },
    create() {
      axios
        .post("/hosts/labels", {
          hosts: this.ruleForm.hosts,
          labels: Object.fromEntries(this.ruleForm.tags)
        })
        .then(() => {
          this.quit();
          this.$message.success("标签添加成功");
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
